import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import DownloadGuide from './components/DownloadGuide';
import CategoryPreview from './components/CategoryPreview';
import FAQSection from './components/FAQSection';

export default function Home() {
  const webPageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '抖阴pro官方下载 - 热门短视频内容平台',
    description: '抖阴pro是一款备受关注的短视频内容平台应用，为您详细介绍核心功能、使用方法、下载安装流程及常见问题解答。',
    url: 'https://douyinpro.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '抖阴pro',
      url: 'https://douyinpro.com/',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageJsonLd)}</script>
      <main>
        <HeroSection />
        <FeaturesSection />
        <DownloadGuide />
        <CategoryPreview />
        <FAQSection />
      </main>
    </>
  );
}